module.exports = __webpack_public_path__ + "static/contenu-d2ca2e93d33a3b71c9511427e4dc7a78.jpg";